const getPercent = (dividend: number, divisor: number): string => {
  if (divisor == 0) {
    return '0.00%';
  }
  return `${((dividend / divisor) * 100).toFixed(2)}%`;
};

export default getPercent;
